import Select from "react-select";

const MultipleSelect = ({
  options,
  label,
  onSelectChange,
  id,
  isMulti,
  closeMenuOnSelect,
  value,
  defaultValue,
  isDisabled,
}) => {
  const handleSelect = (e) => {
    onSelectChange(id, e);
  };
  return (
    <div>
      <p>{label}</p>
      <Select
        defaultValue={defaultValue}
        value={value}
        onChange={handleSelect}
        closeMenuOnSelect={closeMenuOnSelect ? false : true}
        isMulti={isMulti}
        name={id}
        options={options}
        className="basic-multi-select"
        isDisabled={isDisabled}
        // classNamePrefix="select"
        styles={{
          control: (styles) => ({
            ...styles,
            width: "100%",
          }),
          multiValue: (styles) => {
            return {
              ...styles,
              backgroundColor: "#F6F6F6",
            };
          },
        }}
      />
    </div>
  );
};

export default MultipleSelect;
